var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2298_1168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2298_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 25.4999L26.6671 22.8333V9.33327H21.2671L18.8337 6.6666H13.1671L11.9004 8.0666L10.0004 6.1666L12.0004 3.99993H20.0004L22.4671 6.6666H26.6671C27.4004 6.6666 28.0282 6.92771 28.5504 7.44993C29.0726 7.97216 29.3337 8.59994 29.3337 9.33327V25.4999ZM5.33372 27.9999C4.60039 27.9999 3.97261 27.7388 3.45039 27.2166C2.92817 26.6944 2.66706 26.0666 2.66706 25.3333V9.33327C2.66706 8.59994 2.92817 7.97216 3.45039 7.44993C3.97261 6.92771 4.60039 6.6666 5.33372 6.6666H6.70039L9.36706 9.33327H5.33372V25.3333H25.3671L28.0337 27.9999H5.33372ZM20.8671 20.8333C20.3115 21.5888 19.6171 22.1944 18.7837 22.6499C17.9504 23.1055 17.0226 23.3333 16.0004 23.3333C14.3337 23.3333 12.9171 22.7499 11.7504 21.5833C10.5837 20.4166 10.0004 18.9999 10.0004 17.3333C10.0004 16.311 10.2282 15.3833 10.6837 14.5499C11.1393 13.7166 11.7448 13.0222 12.5004 12.4666L14.4337 14.3999C13.9004 14.6888 13.4726 15.0888 13.1504 15.5999C12.8282 16.111 12.6671 16.6888 12.6671 17.3333C12.6671 18.2666 12.9893 19.0555 13.6337 19.6999C14.2782 20.3444 15.0671 20.6666 16.0004 20.6666C16.6448 20.6666 17.2226 20.5055 17.7337 20.1833C18.2448 19.861 18.6448 19.4333 18.9337 18.8999L20.8671 20.8333ZM20.2671 13.0666C20.8226 13.5999 21.2504 14.2333 21.5504 14.9666C21.8504 15.6999 22.0004 16.4888 22.0004 17.3333V17.7333C22.0004 17.8666 21.9893 17.9999 21.9671 18.1333L15.2004 11.3666C15.3337 11.3444 15.4671 11.3333 15.6004 11.3333H16.0004C16.8448 11.3333 17.6337 11.4833 18.3671 11.7833C19.1004 12.0833 19.7337 12.511 20.2671 13.0666ZM27.3004 31.0666L0.900391 4.6666L2.80039 2.7666L29.2004 29.1666L27.3004 31.0666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDenied);
export default __webpack_public_path__ + "static/media/camera_denied.a494cfaad8cc6c5894d054e2b46ee844.svg";
export { ForwardRef as ReactComponent };